import { render } from "./ListeReglement.vue?vue&type=template&id=60981fcc&ts=true"
import script from "./ListeReglement.vue?vue&type=script&lang=ts"
export * from "./ListeReglement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__